import { useState } from 'react';

import './style.css';

const LoginPage = ({ onLogin }) => {
	const [email, setEmail] = useState('admin@example.com');
	const [password, setPassword] = useState('12345');
	const [error, setError] = useState('');

	const handleSubmit = (e) => {
		e.preventDefault();
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			setError('Bitte geben Sie eine gültige E-Mail-Adresse ein');
			return;
		}
		if (password.trim() === '') {
			setError('Bitte füllen Sie alle Felder aus');
			return;
		}

		setError('');
		if (onLogin) {
			onLogin();
		}
	};

	return (
		<form action="submit" className="login-form" onSubmit={handleSubmit}>
			<input
				className="login-input"
				type="email"
				placeholder="Email"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
			/>
			<input
				className="login-input"
				type="password"
				placeholder="Passwort"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
			/>
			{error && <div className="error-message">{error}</div>}
			<div className="login-button__wrapper">
				<button type="submit" className="login-button">
					Enter
				</button>
			</div>
		</form>
	);
};

export default LoginPage;
